// extracted by mini-css-extract-plugin
module.exports = {"title":"EnterpriseAnnouncementModal_title__WhqhG"};